"use client";

import { useEffect, useState } from "react";
import { getProviderList } from "../services/providerService";
import { type Translationtype } from "utils";

interface IProviderIndicatorProps {
  value: string;
  t: Translationtype;
}
export function ProviderIndicator({ value, t }: IProviderIndicatorProps) {
  const [provider, setProvider] = useState<string>("");

  useEffect(() => {
    getProviderList(value).then((resp) => setProvider(resp[0].name || "-"));
  }, [value]);

  if (value === undefined || null) {
    return null;
  }

  return (
    <div className="my-3">
      {value ? (
        <kbd className="kbd kbd-md font-bold text-md w-fit">
          {`${t("Global.providerId")}: ${provider}`}
        </kbd>
      ) : null}
    </div>
  );
}
